import React, { useEffect, useState } from "react";
import { Container, Grid, Button, Box, Select, MenuItem } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";

import {
  findFundAbbById,
  findFundById,
  TABLE_HEAD_FUND_REBALANCE_EXISTING,
} from "../../../../component/Methods";
import Approved from "./components/Approved";
import Adjusted from "./components/Adjusted";
import Rejected from "./components/Rejected";
import { useDispatch} from "react-redux";
import {
  addActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../../../Redux/Reducers/uiSlice";
import { sendWebSocketMessage } from "../../../../hooks/useWebSocket";
import { useRebalancerState } from "../../../../hooks/useOptimizedState";
const FundStep5 = ({
  setCurrentStep,
  rebalancedFunds,
  onPrevious,
  rebalanceType,
}) => {
  const [approved, setApproved] = useState([]);
  const [rejected, setRejected] = useState([]);
  const [partial, setPartial] = useState([]);
  const [missingLocates, setMissingLocates] = useState([]);
  const dispatch = useDispatch();

  const { funds, AllTrades } = useRebalancerState();
  useEffect(() => {
    if (AllTrades && Array.isArray(AllTrades?.realOrders)) {
      setApproved([]);
      setRejected([]);
      setPartial([]);
      setMissingLocates([]);

      const realOrders = AllTrades.realOrders;
      const approvedData = [];
      const rejectedData = [];
      const partialData = [];
      const missingLocatesTemp = [];

      const realOrdersFiltered = realOrders.filter(
        (trade) => trade?.position !== 0
      );

      realOrdersFiltered.forEach((trade) => {
        const { ticker, shareCount, availableLocates, fund, residual } = trade;
        const val = residual || residual === 0 ? residual : shareCount;
        const fundVal = findFundAbbById(fund, funds);
        const tickerVal = ticker?.stock
          ? `${ticker.symbol}/${ticker.stock}`
          : ticker?.symbol;

        if (availableLocates >= val) {
          approvedData.push({
            ticker: tickerVal,
            shareCount: val,
            fund: fundVal,
          });
        } else if (availableLocates === 0) {
          rejectedData.push({
            ticker: tickerVal,
            shareCount: val,
            fund: fundVal,
          });
          missingLocatesTemp.push({
            ticker: tickerVal,
            missing: val,
            fund: findFundById(fundVal, funds),
          });
        } else if (availableLocates < val) {
          const missing = val - availableLocates;
          partialData.push({
            ticker: tickerVal,
            shareCount: missing,
            fund: fundVal,
          });
          approvedData.push({
            ticker: tickerVal,
            shareCount: availableLocates,
            fund: fundVal,
          });
          missingLocatesTemp.push({
            ticker: tickerVal,
            missing,
            fund: findFundById(fundVal, funds),
          });
        }
      });

      setApproved(approvedData);
      setRejected(rejectedData);
      setPartial(partialData);
      setMissingLocates(missingLocatesTemp);
    } else {
      setApproved([]);
      setRejected([]);
      setPartial([]);
      setMissingLocates([]);
    }
  }, [AllTrades]);

  useEffect(() => {
    return () => {
      setApproved([]);
      setRejected([]);
      setPartial([]);
      setMissingLocates([]);
    };
  }, []);

  const onNext = () => {
    const transformedLocates = missingLocates.reduce(
      (acc, { ticker, missing, fund }) => {
        if (!acc[fund]) {
          acc[fund] = [];
        }
        acc[fund].push({ ticker, missing });
        return acc;
      },
      {}
    );
    const socketRequest1 = {
      action: "rebalancer_locates",
      data: {
        processId: AllTrades.processId,
        missingLocates: transformedLocates,
        proccedToFinalize: true,
        rebalancerType: rebalanceType === "all" ? 1 : 0,
      },
    };

    sendWebSocketMessage(JSON.stringify(socketRequest1));
    dispatch(addActiveRequests("rebalancer_locates"));
    const socketRequest2 = {
      action: "rebalancer_summary",
      data: {
        processId: AllTrades.processId,
        fundIds: rebalancedFunds,
        rebalancerType: rebalanceType === "all" ? 1 : 0,
      },
    };
    sendWebSocketMessage(JSON.stringify(socketRequest2));
    dispatch(addActiveRequests("rebalancer_summary"));

    dispatch(updateLoading(true));
    dispatch(updateLoadingMsg("Generating Summary"));
    setCurrentStep((prev) => prev + 1);
  };

  const onNormalize = () => {
    const transformedLocates = missingLocates.reduce(
      (acc, { ticker, missing, fund }) => {
        if (!acc[fund]) {
          acc[fund] = [];
        }
        acc[fund].push({ ticker, missing });
        return acc;
      },
      {}
    );
    const socketRequest1 = {
      action: "rebalancer_locates",
      data: {
        processId: AllTrades.processId,
        missingLocates: transformedLocates,
        rebalancerType: rebalanceType === "all" ? 1 : 0,
      },
    };
    sendWebSocketMessage(JSON.stringify(socketRequest1));

    dispatch(addActiveRequests("rebalancer_locates"));
    dispatch(updateLoading(true));
    dispatch(updateLoadingMsg("Normalizing Locates"));

    setCurrentStep((prev) => {
      const prevStep = prev - 1;
      return prevStep;
    });
  };
  return (
    <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="contained"
                color="warning"
                startIcon={<RefreshIcon />}
                onClick={onNormalize}
                disabled={partial.length === 0 && rejected.length === 0}
                sx={{ width: "150px", height: "40px" }}
              >
                NORMALIZE
              </Button>
              <Button
                variant="contained"
                color="grey"
                startIcon={<ArrowBackIcon />}
                onClick={onPrevious}
                sx={{ width: "150px", height: "40px" }}
              >
                BACK
              </Button>
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                disabled={partial.length != 0 || rejected.length != 0}
                onClick={onNext}
                sx={{ width: "150px", height: "40px" }}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "70%",
              justifyContent: "space-between",
            }}
          >
            <Approved
              approved={approved}
              tableHeader={TABLE_HEAD_FUND_REBALANCE_EXISTING}
            />

            <Rejected
              rejected={rejected}
              tableHeader={TABLE_HEAD_FUND_REBALANCE_EXISTING}
            />

            <Adjusted
              adjusted={partial}
              tableHeader={TABLE_HEAD_FUND_REBALANCE_EXISTING}
            />
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FundStep5;
